import React from "react";

function Map() {
  return (
    <div
      class='bingwidget'
      data-type='covid19'
      data-market='en-us'
      data-language='en-us'></div>
  );
}

export default Map;
